<script>
export default {
  components: {}
};
</script>

<style scoped>
#auth-container {
  background-image: url('~@/assets/images/background/back.png'); 
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  background-attachment: local;
  height: 1080px;
}
</style>

<template>
  <div id="auth-container" class="pt-0 pt-sm-1 d-xs-none" >
    <div class="account-pages my-0 pt-0 my-sm-5 pt-sm-5 ">
      <div class="container">
        <slot />
      </div>
    </div>
  </div>
</template>
